<template>
  <!-- there is a brief moment during logout when old timeline gets forcibly deactivated -->
  <div v-if="timeline.fetcher" :class="['Timeline', classes.root]">
    <div
      v-if="header !== 'none' && header !== 'embedded'"
      :class="classes.header"
    >
      <TimelineMenu
        v-if="header === 'full'"
        :timeline-name="timelineRef.name"
      />
      <div
        v-else-if="header === 'page'"
        class="timeline-page-title"
      >
        <button
          class="button-unstyled go-back-button"
          :title="$t('nav.back')"
          :aria-label="$t('nav.back')"
          @click="goBack"
        >
          <FAIcon
            fixed-width
            icon="chevron-left"
          />
        </button>
        <h1 class="title">
          {{ $t('nav.quotes') }}
        </h1>
      </div>
      <template v-if="timelineRef.name === 'tag'">
        <TagCombine
          :argument="timelineRef.argument"
          class="timeline-tag-combine"
        />
        <TagFollowButton
          v-if="currentUser"
          :tag="mainTag"
          class="timeline-tag-follow"
        />
      </template>
      <template v-if="newPostsInHeader">
        <div
          v-if="timeline.fetcher.loadingNewer && !showLoadButton"
          class="loadingIndicator"
        >
          <FAIcon
            fixed-width
            icon="circle-notch"
            spin
          />
        </div>
        <ScrollTopButton />
        <button
          v-if="showLoadButton"
          class="button-default loadmore-button"
          @click.prevent="showNewStatusesAtTop"
        >
          {{ loadButtonString }}
        </button>
        <div
          v-else
          class="loadmore-text faint"
          @click.prevent
        >
          {{ $t('timeline.up_to_date') }}
        </div>
        <TimelineSettingsMenu class="rightside-button" />
      </template>
    </div>
    <!-- new posts, said once to a screen reader (not each new count); the
         region is always there, so that its change is heard -->
    <span
      v-if="header !== 'embedded'"
      class="visible-for-screenreader-only"
      role="status"
    >{{ showLoadButton ? $t('timeline.new_posts') : '' }}</span>
    <!-- a phone has no header row: new posts float over the top -->
    <div
      v-if="!newPostsInHeader && header !== 'embedded' && showLoadButton"
      class="new-posts-pill-holder"
    >
      <button
        class="button-default new-posts-pill"
        @click.prevent="showNewStatusesAtTop"
      >
        <FAIcon icon="chevron-up" />
        {{ loadButtonString }}
      </button>
    </div>
    <div :class="classes.body">
      <div
        ref="timeline"
        class="timeline"
        role="feed"
      >
        <Conversation
          v-for="status in filteredVisibleStatuses"
          :key="status.id"
          role="listitem"
          class="status-fadein"
          :status-id="status.id"
          :in-profile="inProfile"
          :filter-place="filterPlace"
          :profile-user-id="timelineRef.argument"
          :virtual-hidden="virtualScrollingEnabled && !statusesToDisplay.has(status.id)"
          collapsable
        />
      </div>
      <template v-if="!hideEmpty && count === 0">
        <PanelLoading
          v-if="showLoadingPlaceholder"
          class="timeline-placeholder"
        />
        <EmptyState
          v-else
          class="timeline-placeholder"
          icon="stream"
          :message="$t('timeline.no_statuses')"
        />
      </template>
    </div>
    <div
      v-if="(!embedded || footerSlipgate) && footer"
      :class="classes.footer"
    >
      <teleport
        :to="footerSlipgate"
        :disabled="!embedded || !footerSlipgate"
      >
        <div
          v-if="footer === 'end'"
          class="new-status-notification text-center faint"
        >
          {{ $t('timeline.no_more_statuses') }}
        </div>
        <div
          v-else-if="footer === 'loading'"
          class="new-status-notification text-center"
        >
          <FAIcon
            icon="circle-notch"
            spin
            size="lg"
          />
        </div>
        <button
          v-else
          class="button-unstyled -link"
          @click.prevent="fetchOlderStatuses()"
        >
          <div class="new-status-notification text-center">
            {{ $t('timeline.load_older') }}
          </div>
        </button>
      </teleport>
    </div>
  </div>
</template>

<script src="./timeline.js"></script>

<style src="./timeline.scss" lang="scss"> </style>
